import React from 'react';

type ClickCallback = (event: globalThis.MouseEvent) => void;

export const useClickOutside = <T extends Node>(callback: ClickCallback): React.RefObject<T> => {
  const ref = React.useRef<T>(null);
  const handleClick: ClickCallback = React.useCallback(
    (e) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        callback(e);
      }
    },
    [callback],
  );

  React.useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [handleClick]);

  return ref;
};
